import { useState, useEffect } from 'react';
import { SEOData } from '../../components/SEOData';
import { Layout } from '../../components/Layout';
import { SignIn } from '../../components/SignIn/SignIn';
import { SignInMachineContext } from '../../machines/sign-in/SignInMachineContext';
import { AwsWafScript } from '../../components/AwsWafScript';

const Login = () => {
  const [isChatWidgetLogin, setIsChatWidgetLogin] = useState(false);

  useEffect(() => {
    // using URLSearchParams to get the query params from the URL instead of
    // useRouter because useRouter returns undefined when the query param is not
    // explicitly set to a value
    // ex: `http://wwww.stitchfix.com/login?fromchatwidget`
    const params = new URLSearchParams(window.location.search);
    const fromChatWidget = params.get('fromchatwidget') !== null;

    // If the user is coming from the chat widget, we want to hide the header
    // and footer
    setIsChatWidgetLogin(fromChatWidget);
  }, []);

  return (
    <>
      <Layout
        viewEventTrackingName="login"
        forceHideHeaderFooter={isChatWidgetLogin}
      >
        <SEOData
          canonicalUrl="https://www.stitchfix.com/login"
          title="Sign In | Personal Styling for Women, Men &amp; Kids"
          description="Looking to access your Stitch Fix account? Log in to get started, update your account, make exchanges and provide feedback for your Stylist!"
          openGraphDescription="You’ve got to try this! Stitch Fix is the personal styling service for men, women &amp; kids that sends handpicked clothing to your door (with free shipping &amp; returns!). Get started now."
        />
        <SignInMachineContext.Provider
          options={{ context: { isWafEnabled: true } }}
        >
          <SignIn />
        </SignInMachineContext.Provider>
      </Layout>
      <AwsWafScript page="/login" />
    </>
  );
};

export default Login;
